import {
  PROFILE_INFO_URI,
  SAVE_LOGIN_TOKEN,
  UPDATE_PROFILE_URI,
} from '../common/endpoints';
import { get, post } from '../common/axiosInstance';

import { PROFILE_OPERATION_TYPE } from '../../common/constants';
import { profileResponseTransformer } from './userProfile.transformer';

const profileInfo = function () {
  // gets the profile info
  this.getProfileInfo = async function (params, callback) {
    // const response = await get(PROFILE_INFO_URI(params));
    // callback(profileResponseTransformer(response.data["User Info"]));

    try {
      const apiCall = async () => {
        const response = await get(PROFILE_INFO_URI(params));
        return response.data['User Info'];
      };

      const timeout = new Promise((_, reject) => {
        setTimeout(() => {
          reject(new Error('API timeout'));
        }, 15000);
      });

      await Promise.race([apiCall(), timeout])
        .then((data) => {
          callback(profileResponseTransformer(data));
        })
        .catch((error) => {
          console.error('Error fetching profile info:', error);
          if (error.message === 'API timeout') {
            const userConfirmed = window.confirm(
              'The request is taking too long. Do you want to reload the page?',
            );
            if (userConfirmed) {
              window.location.reload();
            }
          }
        });
    } catch (error) {
      console.error('Error fetching profile info:', error);
    }
  };

  // saves the token received from the login of social media
  this.saveToken = async ({ socialMediaType, params, data, isLogout }) => {
    const url = SAVE_LOGIN_TOKEN(socialMediaType, isLogout);

    const response = await post(SAVE_LOGIN_TOKEN(socialMediaType, isLogout), {
      data,
      params,
    });

    return response;
  };

  // adds the company with the data to the profile info
  this.editCompany = async (params, data, callbackFn) => {
    const response = await post(UPDATE_PROFILE_URI, {
      params: { operation: params.operationType, ...params }, // opration type = addCompany or removeCompany or editCompany
      data,
    });
    // Await the callback (refreshCompaniesProfile → a real GET that repopulates
    // CompaniesContext) so callers awaiting addCompany/editCompany/removeCompany
    // can rely on fresh company data (e.g. newly-saved categories) being in
    // context by the time this resolves, instead of it firing in the
    // background with no ordering guarantee.
    await callbackFn();
    return response;
  };

  // TODO:: check security risk for this API
  // updates the profile info with any data parameter
  this.updateInfo = async (data, callbackFn) => {
    const response = await post(UPDATE_PROFILE_URI, {
      params: { operation: PROFILE_OPERATION_TYPE.updateInfo },
      data: data,
    });
    if (response.data['Profile Info']) {
      callbackFn(
        profileResponseTransformer(response.data['Profile Info']['User Info']),
      );
    } else if (response.data['User Info']) {
      callbackFn(profileResponseTransformer(response.data['User Info']));
    }
  };

  this.profileOperation = ({
    params,
    callbackFn,
    socialMediaType,
    isLinkedInLogout,
    isHubspotLogout,
    isTiktokLogout,
    profileOperationType,
    isDiscordLogout,
    isSalesForceLogout,
    data,
  }) => {
    switch (profileOperationType) {
      case PROFILE_OPERATION_TYPE.socialMediaSaveToken:
        if (socialMediaType) {
          return this.saveToken({
            socialMediaType,
            params,
            data,
            isLinkedInLogout,
            isHubspotLogout,
            isDiscordLogout,
            isSalesForceLogout,
          });
        }
        break;

      case PROFILE_OPERATION_TYPE.socialMediaLogout:
        if (socialMediaType) {
          const isLogout =
            isLinkedInLogout ||
            isTiktokLogout ||
            isHubspotLogout ||
            isDiscordLogout ||
            isSalesForceLogout;

          return this.saveToken({ socialMediaType, params, data, isLogout });
        }
        break;

      case PROFILE_OPERATION_TYPE.updateInfo:
        return this.updateInfo(data, callbackFn);

      case PROFILE_OPERATION_TYPE.getProfileInfo:
        return this.getProfileInfo(params, callbackFn);

      case PROFILE_OPERATION_TYPE.addCompany:
      case PROFILE_OPERATION_TYPE.removeCompany:
      case PROFILE_OPERATION_TYPE.editCompany:
        return this.editCompany(params, data, callbackFn);

      default:
        return this.getProfileInfo(params, callbackFn);
    }
  };
};

export const profileOperationHandler = new profileInfo().profileOperation;

// import {
//   PROFILE_INFO_URI,
//   SAVE_LOGIN_TOKEN,
//   UPDATE_PROFILE_URI,
// } from '../common/endpoints';
// import { get, post } from '../common/axiosInstance';

// import { PROFILE_OPERATION_TYPE } from '../../common/constants';
// import { profileResponseTransformer } from './userProfile.transformer';

// const profileInfo = function () {
//   // gets the profile info
//   this.getProfileInfo = async function (params, callback) {
//     const response = await get(PROFILE_INFO_URI(params));
//     callback(profileResponseTransformer(response.data['User Info']));
//   };

//   // saves the token received from the login of social media
//   this.saveToken = async ({ socialMediaType, params, data, isLogout }) => {
//     const url = SAVE_LOGIN_TOKEN(socialMediaType, isLogout);

//     const response = await post(SAVE_LOGIN_TOKEN(socialMediaType, isLogout), {
//       data,
//       params,
//     });

//     return response;
//   };

//   // adds the company with the data to the profile info
//   this.editCompany = async (params, data, callbackFn) => {
//     const response = await post(UPDATE_PROFILE_URI, {
//       params: { operation: params.operationType, ...params }, // opration type = addCompany or removeCompany or editCompany
//       data,
//     });
//     callbackFn();
//     return response;
//   };

//   // TODO:: check security risk for this API
//   // updates the profile info with any data parameter
//   this.updateInfo = async (data, callbackFn) => {
//     const response = await post(UPDATE_PROFILE_URI, {
//       params: { operation: PROFILE_OPERATION_TYPE.updateInfo },
//       data: data,
//     });
//     if (response.data['Profile Info']) {
//       callbackFn(
//         profileResponseTransformer(response.data['Profile Info']['User Info']),
//       );
//     } else if (response.data['User Info']) {
//       callbackFn(profileResponseTransformer(response.data['User Info']));
//     }
//   };

//   this.profileOperation = ({
//     params,
//     callbackFn,
//     socialMediaType,
//     isLinkedInLogout,
//     isHubspotLogout,
//     isTiktokLogout,
//     profileOperationType,
//     isDiscordLogout,
//     isSalesForceLogout,
//     data,
//   }) => {
//     switch (profileOperationType) {
//       case PROFILE_OPERATION_TYPE.socialMediaSaveToken:
//         if (socialMediaType) {
//           return this.saveToken({
//             socialMediaType,
//             params,
//             data,
//             isLinkedInLogout,
//             isHubspotLogout,
//             isDiscordLogout,
//             isSalesForceLogout,
//           });
//         }
//         break;

//       case PROFILE_OPERATION_TYPE.socialMediaLogout:
//         if (socialMediaType) {
//           const isLogout =
//             isLinkedInLogout ||
//             isTiktokLogout ||
//             isHubspotLogout ||
//             isDiscordLogout ||
//             isSalesForceLogout;

//           return this.saveToken({ socialMediaType, params, data, isLogout });
//         }
//         break;

//       case PROFILE_OPERATION_TYPE.updateInfo:
//         return this.updateInfo(data, callbackFn);

//       case PROFILE_OPERATION_TYPE.getProfileInfo:
//         return this.getProfileInfo(params, callbackFn);

//       case PROFILE_OPERATION_TYPE.addCompany:
//       case PROFILE_OPERATION_TYPE.removeCompany:
//       case PROFILE_OPERATION_TYPE.editCompany:
//         return this.editCompany(params, data, callbackFn);

//       default:
//         return this.getProfileInfo(params, callbackFn);
//     }
//   };
// };

// export const profileOperationHandler = new profileInfo().profileOperation;
